import { Col, Form, Input, Radio, Row } from "antd";
import { translate } from "../../../core";
import { useContext } from "react";
import { ContactEntryAddresses } from "./ContactEntryAddresses";
import { ContactEntryPhones } from "./ContactEntryPhones";
import { ContactEntryWebInfos } from "./ContactEntryWebInfos";
import { PageContextValue } from "../../../core/type";
import { ContactEntry, ContactType } from "../type/contact-entry";
import { ContactFormGroup } from "./ContactFormGroup";
import { ContactPageContext } from "./ContactPageContext";
import { Contact } from "../type/contact";
import styles from "./ContactForm.module.scss";
import { InputCard } from "../../inventory/component/InputCard";

export const ContactFormCustomer = ({
  contactTypeDisabled,
}: {
  contactTypeDisabled?: boolean;
}) => {
  const { save, form, onFormChange } =
    useContext<PageContextValue<Contact, ContactEntry>>(ContactPageContext);

  return (
    <div className="px-3 py-3">
      <Form
        onFieldsChange={() => {
          onFormChange!();
        }}
        layout="horizontal"
        form={form}
        onFinish={save}
        className={styles.formRoot}
      >
        <InputCard
          title={translate("information")}
          contained
          className={styles.card + " py-3 mb-4"}
        >
          <Row gutter={[10, 10]}>
            <Col span={24}>
              <Form.Item name="contactType" className="w-100">
                <Radio.Group disabled={true} className="flex">
                  {Object.values(ContactType).map((type) => (
                    <Radio
                      key={type}
                      className={["items-center", styles.radio].join(" ")}
                      value={type}
                    >
                      {type}
                    </Radio>
                  ))}
                </Radio.Group>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label={translate("relation", "group")}
                name={["group", "id"]}
                className="my-1 w-100"
              >
                <ContactFormGroup />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label={translate("contact_id")}
                name="contactId"
                rules={[
                  {
                    required: true,
                    message: translate("missing_field_message", "contract_id"),
                  },
                ]}
                className="w-100"
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={[10, 10]}>
            <Col span={12}>
              <Form.Item
                label={translate("first_name")}
                name="firstName"
                className="my-1 w-100"
            >
              <Input />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label={translate("last_name")}
                name="lastName"
                className="my-1 w-100"
              >
                <Input />
              </Form.Item>
            </Col>
          </Row>
        </InputCard>

        <Form.List name="addresses">
          {(fields) => (
            <InputCard
              title={translate("address")}
              contained
              className={styles.card + " py-3"}
            >
              {fields.length > 0 &&
                fields.map(({ key, name }) => (
                  <>
                    <div key={key} className="d-flex gap-2">
                      <Form.Item
                        className="my-1 w-100"
                        name={[name, "street"]}
                        label={translate("street")}
                      >
                        <Input />
                      </Form.Item>
                    </div>
                    <div className="d-flex gap-2">
                      <Form.Item
                        className="my-1 w-100"
                        name={[name, "line1"]}
                        label={translate("line", "1")}
                      >
                        <Input />
                      </Form.Item>
                      <Form.Item
                        className="my-1 w-100"
                        name={[name, "line2"]}
                        label={translate("line", "2")}
                      >
                        <Input />
                      </Form.Item>
                    </div>
                    <div className="d-flex gap-2">
                      <Form.Item
                        className="my-1 w-100"
                        name={[name, "city"]}
                        label={translate("city")}
                      >
                        <Input />
                      </Form.Item>
                      <Form.Item
                        className="my-1 w-100"
                        name={[name, "state"]}
                        label={translate("state")}
                      >
                        <Input />
                      </Form.Item>
                    </div>
                    <div className="d-flex gap-2">
                      <Form.Item
                        className="my-1 w-100"
                        name={[name, "zipCode"]}
                        label={translate("zip_code")}
                      >
                        <Input />
                      </Form.Item>
                      <Form.Item
                        className="my-1 w-100"
                        name={[name, "country"]}
                        label={translate("country")}
                      >
                        <Input />
                      </Form.Item>
                    </div>
                  </>
                ))}
            </InputCard>
          )}
        </Form.List>

        <ContactEntryPhones />

        <ContactEntryWebInfos />
      </Form>
    </div>
  );
};
